

















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ inheritAttrs: false })
export default class BaseButton extends Vue {
  @Prop({ required: false })
  isActive!: string;

  @Prop({ required: false, default: "button" })
  defaultButtonClass!: string;

  @Prop({ required: false, default: "" })
  buttonClass!: string;

  @Prop({ required: false, default: "" })
  tooltipTitle!: string;

  @Prop({ required: false, default: "" })
  tooltipPosition!: "left" | "right";

  @Prop({ required: false, default: false })
  noBorder!: boolean;

  hover = false;

  get activeClass() {
    return this.isActive ? "active" : "";
  }

  get disabledClass() {
    return this.$attrs["disabled"] ? "disabled" : "";
  }

  get noBorderClass() {
    return this.noBorder ? "no-border" : "";
  }
}
